import { type AssignmentInfo } from '@blaze-shared/api-contracts-domain';
import { type RuntimeContext } from '@blaze-shared/elements-domain';

export function evaluateNavigateUrlParameters(
  urlParameters: AssignmentInfo[] | undefined,
  runtimeContext: RuntimeContext,
  canEvaluate: (value: string) => boolean,
  evaluate: (value: string, context: RuntimeContext) => unknown,
): Record<string, string> {
  const queryParams: Record<string, string> = {};

  for (const param of urlParameters ?? []) {
    const name = param.name?.trim();
    if (!name) {
      continue;
    }

    let value = param.value ?? '';
    if (value && canEvaluate(value)) {
      const evaluated = evaluate(value, runtimeContext);
      value = evaluated == null ? '' : String(evaluated);
    }

    // Omit empty values so page-level defaultValue can still apply when the param is absent.
    if (value === '') {
      continue;
    }

    queryParams[name] = value;
  }

  return queryParams;
}
